import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import './i18n';
import store from './state/store';
import PrivateRoute from "routes/PrivateRoute";
import MerchantLayout from "layouts/Merchant";

ReactDOM.render(
  <Provider store={store}>
  <HashRouter>
    <Switch>
      <Route path="/auth" component={AuthLayout} />
      <PrivateRoute path="/admin" component={AdminLayout} />
      <PrivateRoute path="/merchant" component={MerchantLayout} />
      <Redirect from="/" to="/auth/signin" />
    </Switch>
  </HashRouter>
  </Provider>,
  document.getElementById("root")
);

// Uncomment this line if the service worker is causing issues
// serviceWorkerRegistration.unregister();
serviceWorkerRegistration.register();

reportWebVitals();
